// @ts-nocheck





/* eslint-disable import/order */







import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import FareMediaBatchesTable from './FareMediaBatchesTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFareMediaBatches } from 'selectors';
import AddFareMediaBatch from './addFareMediaBatch';
import EditFareMediaBatch from './updateFareMediaBatch';
import ViewFareMediaBatch from './view-FareMediaBatch';

const FareMediaBatches: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasFareMediaBatchesAddAccess = useTypedSelector(state =>
    hasWriteAccessToFareMediaBatches(state)
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasFareMediaBatchesAddAccess ? <AddFareMediaBatch/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasFareMediaBatchesAddAccess ? <EditFareMediaBatch/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id`}>
          <ViewFareMediaBatch/>
        </Route>

        <Route exact path={`${baseURL}`}>
          <FareMediaBatchesTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FareMediaBatches };
